<div class="dialog-overlay">
    <div class="holiday-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Add Holiday</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        <div class="dialog-content">
            <form #holidayform="ngForm" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">       
                            <label>Holiday Type</label>
                            <div class="col-sm-12">
                                <select name="holidaytype" ngModel required #holidaytype="ngModel" class="infofield">
                                    <option value="" disabled selected>Select Holiday Type</option>
                                    <option value="0">Holiday</option>
                                    <option value="1">WeekEnd</option>
                                    <option value="2">Optional</option>
                                    <option value="3">Event</option>
                                </select>
                                <div class="erroMessage" *ngIf="holidaytype.invalid && holidaytype.touched">
                                    Please Select Valid Holiday Type
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Holiday Name</label>
                            <div class="col-sm-12">
                                <input
                                    type="text"
                                    placeholder="Enter The Name"
                                    required
                                    #holiday="ngModel"
                                    name="holidayname"
                                    pattern="^(?!\s*$)([\s\S]+)$"
                                    ngModel
                                    class="infofield"
                                />
                                <div class="erroMessage" *ngIf="holiday.invalid && holiday.touched">
                                    Please Enter Valid Holiday
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label>Holiday Date</label>
                            <div class="col-sm-12">
                                <input
                                    matInput
                                    [matDatepicker]="pickerfrom"
                                    placeholder="From (dd-mm-yyyy)"
                                    name="holidaydate"
                                    required
                                    #holidaydate="ngModel"
                                    ngModel
                                    (click)="pickerfrom.open()"
                                    class="infofield"
                                />
                                <mat-datepicker-toggle matSuffix [for]="pickerfrom"></mat-datepicker-toggle>
                                <mat-datepicker #pickerfrom></mat-datepicker>
                                <div class="erroMessage" *ngIf="holidaydate.invalid && holidaydate.touched">
                                    Please Select Valid Date
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col" *ngIf="holidaytype.value != '3'">
                        <!-- Empty column for layout consistency when not event -->
                    </div>
                    <div class="col" *ngIf="holidaytype.value == '3'">
                        <div class="row">
                            <label>Event Type</label>
                            <div class="col-sm-12">
                                <select name="eventtype" [(ngModel)]="selectedEventType" required #eventtype="ngModel" class="infofield">
                                    <option value="offline">Offline</option>
                                    <option value="online">Online</option>
                                </select>
                                <div class="erroMessage" *ngIf="eventtype.invalid && eventtype.touched">
                                    Please Select Event Type
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="holidaytype.value == '3'">
                    <div class="col">
                        <div class="row">
                            <label>Event Description</label>
                            <div class="col-sm-12">
                                <textarea
                                    maxlength="400"
                                    required
                                    placeholder="Enter Event Description"
                                    name="eventdescription"
                                    #description="ngModel"
                                    pattern="^(?!\s*$)([\s\S]+)$"
                                    ngModel
                                    class="infofield"
                                    rows="3"
                                ></textarea>
                                <div class="erroMessage" *ngIf="description.invalid && description.touched">
                                    Please Enter Descriptions
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Event Location</label>
                            <div class="col-sm-12">
                                <input
                                    type="text"
                                    placeholder="Enter Event Location"
                                    name="eventlocation"
                                    required
                                    #eventLocation="ngModel"
                                    pattern="^(?!\s*$)([\s\S]+)$"
                                    ngModel
                                    class="infofield"
                                />
                                <div class="erroMessage" *ngIf="eventLocation.invalid && eventLocation.touched">
                                    Please Enter valid Event Location
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="holidaytype.value == '3'">
                    <div class="col">
                        <div class="row">
                            <label>Start Time</label>
                            <div class="col-sm-12">
                                <select
                                    name="eventstarttime"
                                    required
                                    #selectedtime="ngModel"
                                    ngModel
                                    class="infofield"
                                >
                                    <option value="">Select Start Time</option>
                                    <option value="12:00 AM">12:00 AM</option>
                                    <option value="12:30 AM">12:30 AM</option>
                                    <option value="1:00 AM">1:00 AM</option>
                                    <option value="1:30 AM">1:30 AM</option>
                                    <option value="2:00 AM">2:00 AM</option>
                                    <option value="2:30 AM">2:30 AM</option>
                                    <option value="3:00 AM">3:00 AM</option>
                                    <option value="3:30 AM">3:30 AM</option>
                                    <option value="4:00 AM">4:00 AM</option>
                                    <option value="4:30 AM">4:30 AM</option>
                                    <option value="5:00 AM">5:00 AM</option>
                                    <option value="5:30 AM">5:30 AM</option>
                                    <option value="6:00 AM">6:00 AM</option>
                                    <option value="6:30 AM">6:30 AM</option>
                                    <option value="7:00 AM">7:00 AM</option>
                                    <option value="7:30 AM">7:30 AM</option>
                                    <option value="8:00 AM">8:00 AM</option>
                                    <option value="8:30 AM">8:30 AM</option>
                                    <option value="9:00 AM">9:00 AM</option>
                                    <option value="9:30 AM">9:30 AM</option>
                                    <option value="10:00 AM">10:00 AM</option>
                                    <option value="10:30 AM">10:30 AM</option>
                                    <option value="11:00 AM">11:00 AM</option>
                                    <option value="11:30 AM">11:30 AM</option>
                                    <option value="12:00 PM">12:00 PM</option>
                                    <option value="12:30 PM">12:30 PM</option>
                                    <option value="1:00 PM">1:00 PM</option>
                                    <option value="1:30 PM">1:30 PM</option>
                                    <option value="2:00 PM">2:00 PM</option>
                                    <option value="2:30 PM">2:30 PM</option>
                                    <option value="3:00 PM">3:00 PM</option>
                                    <option value="3:30 PM">3:30 PM</option>
                                    <option value="4:00 PM">4:00 PM</option>
                                    <option value="4:30 PM">4:30 PM</option>
                                    <option value="5:00 PM">5:00 PM</option>
                                    <option value="5:30 PM">5:30 PM</option>
                                    <option value="6:00 PM">6:00 PM</option>
                                    <option value="6:30 PM">6:30 PM</option>
                                    <option value="7:00 PM">7:00 PM</option>
                                    <option value="7:30 PM">7:30 PM</option>
                                    <option value="8:00 PM">8:00 PM</option>
                                    <option value="8:30 PM">8:30 PM</option>
                                    <option value="9:00 PM">9:00 PM</option>
                                    <option value="9:30 PM">9:30 PM</option>
                                    <option value="10:00 PM">10:00 PM</option>
                                    <option value="10:30 PM">10:30 PM</option>
                                    <option value="11:00 PM">11:00 PM</option>
                                    <option value="11:30 PM">11:30 PM</option>
                                </select>
                                <div class="erroMessage" *ngIf="selectedtime.invalid && selectedtime.touched">
                                    Please Select Event Start Time
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>End Time</label>
                            <div class="col-sm-12">
                                <select
                                    name="eventendtime"
                                    required
                                    #selectedtimes="ngModel"
                                    ngModel
                                    class="infofield"
                                >
                                    <option value="">Select End Time</option>
                                    <option value="12:00 AM">12:00 AM</option>
                                    <option value="12:30 AM">12:30 AM</option>
                                    <option value="1:00 AM">1:00 AM</option>
                                    <option value="1:30 AM">1:30 AM</option>
                                    <option value="2:00 AM">2:00 AM</option>
                                    <option value="2:30 AM">2:30 AM</option>
                                    <option value="3:00 AM">3:00 AM</option>
                                    <option value="3:30 AM">3:30 AM</option>
                                    <option value="4:00 AM">4:00 AM</option>
                                    <option value="4:30 AM">4:30 AM</option>
                                    <option value="5:00 AM">5:00 AM</option>
                                    <option value="5:30 AM">5:30 AM</option>
                                    <option value="6:00 AM">6:00 AM</option>
                                    <option value="6:30 AM">6:30 AM</option>
                                    <option value="7:00 AM">7:00 AM</option>
                                    <option value="7:30 AM">7:30 AM</option>
                                    <option value="8:00 AM">8:00 AM</option>
                                    <option value="8:30 AM">8:30 AM</option>
                                    <option value="9:00 AM">9:00 AM</option>
                                    <option value="9:30 AM">9:30 AM</option>
                                    <option value="10:00 AM">10:00 AM</option>
                                    <option value="10:30 AM">10:30 AM</option>
                                    <option value="11:00 AM">11:00 AM</option>
                                    <option value="11:30 AM">11:30 AM</option>
                                    <option value="12:00 PM">12:00 PM</option>
                                    <option value="12:30 PM">12:30 PM</option>
                                    <option value="1:00 PM">1:00 PM</option>
                                    <option value="1:30 PM">1:30 PM</option>
                                    <option value="2:00 PM">2:00 PM</option>
                                    <option value="2:30 PM">2:30 PM</option>
                                    <option value="3:00 PM">3:00 PM</option>
                                    <option value="3:30 PM">3:30 PM</option>
                                    <option value="4:00 PM">4:00 PM</option>
                                    <option value="4:30 PM">4:30 PM</option>
                                    <option value="5:00 PM">5:00 PM</option>
                                    <option value="5:30 PM">5:30 PM</option>
                                    <option value="6:00 PM">6:00 PM</option>
                                    <option value="6:30 PM">6:30 PM</option>
                                    <option value="7:00 PM">7:00 PM</option>
                                    <option value="7:30 PM">7:30 PM</option>
                                    <option value="8:00 PM">8:00 PM</option>
                                    <option value="8:30 PM">8:30 PM</option>
                                    <option value="9:00 PM">9:00 PM</option>
                                    <option value="9:30 PM">9:30 PM</option>
                                    <option value="10:00 PM">10:00 PM</option>
                                    <option value="10:30 PM">10:30 PM</option>
                                    <option value="11:00 PM">11:00 PM</option>
                                    <option value="11:30 PM">11:30 PM</option>
                                </select>
                                <div class="erroMessage" *ngIf="selectedtimes.invalid && selectedtimes.touched">
                                    Please Select Event End Time
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button 
                type="submit" 
                class="btn btn-primary" 
                [disabled]="holidayform.invalid"
                (click)="_addHoliday(holidayform)">Add Holiday</button>
        </div>
    </div>
</div>